var sortBox = {
    //过滤条件
    filterArr: [],
    relatedFilterArr: [],
    fileTypeFilterArr: [],
    //过滤url
    filterUrl: "",
    //过滤窗显示状态
    isShowFilterBox:false,

    //基础url
    filterBaseUrl:'',
    //排序类型
    sort:'all',
    sortUrl:'',

    //请求文章的api tagsurl
    apiTagsUrl:'',
    subCateArr:[], //子分类的数组
    apiSubCateUrl:'', //子分类的URL

    //过滤器正在打开
    isShowing:false,

    //是否吸顶
    isFixed:false,

    filterTagList: [], //筛选选中的tag 做行为记录

    //注册点击事件
    regFilterEvent: function () {
        var _this = this;

        //点击筛选条件
        $('.filter-list>li').on('click', function () {
            _this.setFilter(this);
        });

        //点击完成
        $('.filter-btbox .done').on('click', function () {
            _this.done(this);
        });

        //点击清空条件
        $('.filter-btbox .clear').on('click', function () {
            _this.clear(this);
        });

        //点击叉号取消筛选
        $('.tag-seled-list>ul>li').on('click', function () {
            $(this).remove();
            _this.done('tab');
        });
        //如果没有选择的标签就隐藏该区域
        if(!$('.tag-seled-list ul li').length){
            $('.tag-seled-list').hide();
        }

        //点击sortTab
        $('.sort-tab-item').on('click', function () {
            var filterTabName = $(this).attr('bt-data');

            _this.sort = filterTabName;

            _this.setSortUrl();

            _this.setFilterUrl();

            //行为记录
            userAction.sort($(this).text());

            //跳转
            if (window.cateData.pageModule == 'premiumList') {
                window.location.replace(_this.filterBaseUrl + _this.filterUrl);
            } else {
                window.location.replace(_this.filterBaseUrl + _this.filterUrl + _this.sortUrl);
            }
            // window.location.href = _this.filterBaseUrl + _this.filterUrl + _this.sortUrl;
        });

        //点击筛选tab
        $('.sort-filter-item').on('click', function () {
            if(_this.isShowFilterBox){
                _this.showFilterBox('hide');
            }else{
                _this.showFilterBox('show');
            }
        });

        //mask
        $('.mask-black').on('click', function () {
            _this.showFilterBox('hide');
        });
        // $('.mask-black').on('touchstart', function(e){
        //     e.stopPropagation();
        //     e.preventDefault();
        // },false);

    },

    //设置展开栏的高度
    setHeight: function () {
        var h = window.innerHeight * 0.5;
        if (window.cateData.pageModule == 'premiumList') {
            $('.filter-content').css({'maxHeight': h + 'px', 'height': 'auto', 'padding-bottom': '.5rem'});
        } else {
            $('.filter-content').height(h);
        }
    },

    setFilter: function (elem) {
        $(elem).toggleClass('filter-seled');
    },

    //完成筛选
    done: function (type) {
        var _this = this;

        _this.showFilterBox('hide');

        _this.setFilterUrl(type);
        var url = window.location.pathname;
        var index = url.lastIndexOf("\/");
        var str = url.substring(index + 1,url.length);
        //如果当前的筛选项没有变更则不跳转
        if(str !== _this.filterUrl){
            if (window.cateData.pageModule == 'premiumList') {
                window.location.replace(_this.filterBaseUrl + _this.filterUrl);
            } else {
                window.location.replace(_this.filterBaseUrl + _this.filterUrl + _this.sortUrl);
            }
            // window.location.href = _this.filterBaseUrl + _this.filterUrl + _this.sortUrl;
        }
    },

    //设置过滤器url
    setFilterUrl: function (type) {
        var _this = this;

        //tags ID 数组
        _this.filterArr = [];
        _this.apiTagsUrl = [];
        _this.subCateArr = [];
        _this.relatedFilterArr = [];
        _this.fileTypeFilterArr = [];

        //行为记录 tag数组
        _this.filterTagList = [];

        _this.filterUrl = ''; //用于跳转链接

        var sdledEles = '';//选择的标签
        if(type === 'tab'){ //判断是下拉中的操作还是tab中的操作
            sdledEles = $('.filter-seled-tab');
        }else{
            sdledEles = $('.filter-seled');
        }
        //获取已选中的tag标签ID数组
        sdledEles.each(function (index, elem) {
            var tagId = elem.getAttribute('filter-id');
            if (window.cateData.pageModule == 'premiumList') {
                var tagBelongField = elem.getAttribute('data-fieldName');
                if (tagBelongField == 'File Type') {
                    _this.fileTypeFilterArr.push(tagId);
                } else {
                    _this.relatedFilterArr.push(tagId);
                }
            } else {
                //解决方案中的类型为子分类需要进行特殊处理
                if(parseInt(tagId)){
                    _this.filterArr.push(tagId);
                }else{
                    _this.subCateArr.push(tagId);
                }
            }
            //行为记录 tag数组
            _this.filterTagList.push(elem.innerText);
        });

        function sortNum(a, b) {
            return a - b;
        }
        if (window.cateData.pageModule == 'premiumList') {
            _this.relatedFilterArr.sort(sortNum);
            _this.fileTypeFilterArr.sort(sortNum);
            _this.filterUrl = this.sortUrl;
            //拼接分类搜索词url
            if (_this.fileTypeFilterArr.length > 0) {
                var fileTypeTagId = _this.fileTypeFilterArr.join('_');
                if (!this.filterUrl) {
                    _this.filterUrl = '?t=' + fileTypeTagId;
                } else {
                    _this.filterUrl += '&t=' + fileTypeTagId;
                }
            }
            if (_this.relatedFilterArr.length > 0) {
                var filterTagId = _this.relatedFilterArr.join('_');
                if (!this.filterUrl) {
                    _this.filterUrl = '?k=' + filterTagId;
                } else {
                    _this.filterUrl += '&k=' + filterTagId;
                }
            }
            return;
        }
        //排序数组
        _this.filterArr.sort(sortNum);

        //开始拼接url
        //处理子分类筛选条件url exp: it_scl
        _this.apiSubCateUrl =  '';
        if(_this.subCateArr.length > 0){
            _this.subCateArr.forEach(function (item, index) {
                if(index === 0){
                    _this.apiSubCateUrl = item;
                }else{
                    _this.apiSubCateUrl += '_' + item;
                }
            });
        }else{
            _this.apiSubCateUrl = '0'; //如果没有选择分类则置为0
        }



        //part1
        if(_this.filterArr.length>0){ //如果tagsArr不为空
            if(window.cateData.pageModule === 'program'  || window.cateData.pageModule === 'filelist'){ //解决方案、资料中心拼接分类
                _this.filterUrl = 'index-'+ _this.apiSubCateUrl + '-';
            }else{
                _this.filterUrl = 'index-';
            }
        }else{ //如果tagsArr为空则结束拼接
            if(_this.apiSubCateUrl === '0'){ //分类url为0 则不拼接到url
                _this.filterUrl = '';
            }else{
                _this.filterUrl = 'index-'+ _this.apiSubCateUrl + '.html';
            }
            return;
        }

        //part2 处理tags
        _this.filterArr.forEach(function (item, index) {
            if(index === 0){
                _this.filterUrl += item;
                _this.apiTagsUrl += '-' + item; //用于列表请求接口
            }else{
                _this.filterUrl += '_' + item;
                _this.apiTagsUrl += '_' + item; //用于列表请求接口
            }
        });

        //part3
        _this.filterUrl = _this.filterUrl + '.html';
    },

    //设置瀑布流获取文章接口的条件部分
    setCnditionUrl:function(){
        if(window.cateData.pageModule === 'tank' || window.cateData.pageModule === 'evaluation'){ //如果是智库则不添加子分类条件
            window.cateData.api.getItemCondition = window.cateData.pageSort + this.apiTagsUrl;
        }else{
            window.cateData.api.getItemCondition = this.apiSubCateUrl + '/'+window.cateData.pageSort + this.apiTagsUrl;
        }
    },

    //还原选中
    reSetSeled:function () {
        $('.filter-list > li').each(function(index, elem){
            if(elem.getAttribute('data-status') === 'on'){
                $(elem).addClass('filter-seled');
            }else{
                $(elem).removeClass('filter-seled');
            }
        });
    },

    //清除所有的
    clear: function () {
        $('.filter-seled').removeClass('filter-seled');
        this.filterArr = [];
    },

    //控制筛选窗的显隐
    showFilterBox: function (display) {
        var _this = this;
        if (display === 'show') {
            _this.scrollToTop();
            _this.isShowing = true;
            _this.isShowFilterBox = true;
            $('.filter-box').removeClass('hide');
            $('.mask-black').removeClass('mask-black-hide');
            setTimeout(function () {
                //延时锁定背景，以防滚动失效
                setScroll.unScroll();
                _this.isShowing = false;
            },800)
        } else {
            //添加限制防止动画未展开就点击关闭导致页面锁住
            if(_this.isShowing){
                return;
            }
            $('.filter-box').addClass('ani-to-top-filter-box');
            $('.filter-box').removeClass('ani-form-top-filter-box');
            setTimeout(function () {

                _this.reSetSeled();
                _this.isShowFilterBox = false;
                $('.filter-box').addClass('hide');
                $('.filter-box').removeClass('ani-to-top-filter-box');
                $('.filter-box').addClass('ani-form-top-filter-box');
            }, 400);
            $('.mask-black').addClass('mask-black-hide');
            setScroll.removeUnScroll();
        }
    },

    //将筛选器滚动至顶部
    scrollToTop:function () {

        //判断是否筛选器是否吸顶
        if(this.isFixed){
            return;
        }

        $('body,html').animate({
                scrollTop: $('.sort-box').offset().top - $('.topbar').height()
            }, 200
        );
    },

    //将筛选器吸顶
    setFixed:function() {
        var _this = this;
        window.onscroll = function () {
            //如果筛选窗口是打开中 或打开状态则不经行吸顶操作
            if(_this.isShowing || _this.isShowFilterBox){
                return;
            }
           if($(window).scrollTop() > (($('.swiper-container-industry').height()?$('.swiper-container-industry').height():0))){
                _this.isFixed = true;
               $('.sort-box').css({'position':'fixed','top':'.9rem','z-index':'6'});
               $('.sort-box-holder ').removeClass('hide');
           }else{
               _this.isFixed = false;
               $('.sort-box').css({'position':'relative','top':'0','z-index':'2'});
               $('.sort-box-holder ').addClass('hide');
           }
        };
    },

    setOption:function(){
        this.filterBaseUrl = window.cateData.pageModule == 'premiumList' ? window.cateData.url.premiumPage : window.cateData.url.page;
        this.sort = window.cateData.pageSort;
        //当前sortTab
        this.setSortUrl();
    },

    setSortUrl:function(){
        if(this.sort === 'all'){
            this.sortUrl = '';
        }else{
            this.sortUrl = '?sort=' + this.sort;
        }
    },

    setFilterTabSeld: function(){
        if(this.filterArr.length >0 || this.subCateArr.length > 0){
            $('.sort-filter-item').addClass('seled');
        }
    },

    init: function () {
        this.setOption();
        this.regFilterEvent();
        this.setHeight();
        this.setFilterUrl();
        this.setCnditionUrl();
        this.setFilterTabSeld();
        this.setFixed();

        // 记录筛选行为
        if (this.filterTagList.length > 0) userAction.filterFiles(this.filterTagList.toString());
    },
};
if($('.sort-box').length){
    sortBox.init();
}
